import api from "../../../../services/api";

const getSignature = () => localStorage.getItem("signature");

const post = async (path: string, body: Record<string, any>) => {
  const response = await api.post(path, {
    signature: getSignature(),
    ...body,
  });
  return response.data?.data;
};

export const autoSchedule = async (
  companyId: string,
  companyType: string,
  payload: Record<string, any>
) =>
  post("projectService/scheduling/autoSchedule", {
    company_id: companyId,
    company_type: companyType,
    ...payload,
  });

export const getCriticalPath = async (
  companyId: string,
  companyType: string,
  projectId: number
) =>
  post("projectService/scheduling/getCriticalPath", {
    company_id: companyId,
    company_type: companyType,
    project_id: projectId,
  });

export const getCapacity = async (
  companyId: string,
  companyType: string,
  projectId: number
) =>
  post("projectService/scheduling/getCapacity", {
    company_id: companyId,
    company_type: companyType,
    project_id: projectId,
  });
